module.exports = __webpack_public_path__ + "static/4-bdd60102f7886981805d257e819a9ec4.jpg";